import { BACKEND_URL, EMPTY_IMAGE } from '@/constants';

export const getBackendImage = (image?: string) => {
  if (!image) {
    return EMPTY_IMAGE;
  }

  return `${BACKEND_URL}${image}`;
};
